(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
class HeroCarousel extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-carousel__dot'));
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval, 10) || 6000;
    this.timer = null;
  }

  connectedCallback() {
    // Defensive kick for slide 1 video — autoplay attribute usually handles
    // it, but Safari occasionally needs the explicit call.
    this.playSlideVideos(0);

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
      });
    });

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.start());

    // Touch swipe on mobile / touch devices
    this.bindSwipe();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.start();
  }

  bindSwipe() {
    let startX = 0;
    let startY = 0;
    let active = false;
    const threshold = 40;
    const target = this.querySelector('.hero-carousel__slides') || this;

    target.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      active = true;
      this.pause();
    }, { passive: true });

    target.addEventListener('touchmove', (e) => {
      if (!active || e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      // If dominantly vertical, abort (let page scroll)
      if (Math.abs(dy) > Math.abs(dx)) {
        active = false;
      }
    }, { passive: true });

    target.addEventListener('touchend', (e) => {
      if (!active) {
        this.start();
        return;
      }
      active = false;
      const dx = (e.changedTouches[0] || {}).clientX - startX;
      if (Math.abs(dx) > threshold) {
        this.goTo(this.current + (dx < 0 ? 1 : -1));
      }
      this.start();
    }, { passive: true });

    target.addEventListener('touchcancel', () => {
      active = false;
      this.start();
    }, { passive: true });
  }

  disconnectedCallback() {
    this.pause();
  }

  goTo(index) {
    const total = this.slides.length;
    const next = ((index % total) + total) % total;
    if (next === this.current) return;

    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    this.slides[next].classList.add('is-active');
    this.slides[next].removeAttribute('aria-hidden');

    this.dots[this.current].classList.remove('is-active');
    this.dots[this.current].setAttribute('aria-selected', 'false');
    this.dots[next].classList.add('is-active');
    this.dots[next].setAttribute('aria-selected', 'true');

    // Slides use visibility:hidden when inactive, so HTML autoplay only fires
    // for slide 1 on initial load. Manually play/pause videos on slide change.
    this.pauseSlideVideos(this.current);
    this.playSlideVideos(next);

    this.current = next;
    this.restart();
  }

  playSlideVideos(slideIndex) {
    const videos = this.slides[slideIndex].querySelectorAll('video');
    videos.forEach((v) => {
      // Reset to start so each loop cycle plays from frame 0
      try { v.currentTime = 0; } catch (e) {}
      // play() returns a promise — swallow rejection (autoplay blocked, etc.)
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    });
  }

  pauseSlideVideos(slideIndex) {
    const videos = this.slides[slideIndex].querySelectorAll('video');
    videos.forEach((v) => v.pause());
  }

  start() {
    if (!this.autoplay || this.slides.length <= 1) return;
    this.pause();
    this.timer = window.setInterval(() => {
      this.goTo(this.current + 1);
    }, this.interval);
  }

  pause() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (this.timer) {
      this.pause();
      this.start();
    }
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(scroller) {
    var section = scroller.closest('.ing-grid');
    if (!section) return;
    var thumb = section.querySelector('[data-ing-progress-thumb]');
    var track = section.querySelector('[data-ing-progress]');
    if (!thumb || !track) return;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1) {
        track.style.display = 'none';
        return;
      }
      track.style.display = '';
      var visibleRatio = scroller.clientWidth / scroller.scrollWidth;
      var thumbPct = Math.max(0.15, Math.min(1, visibleRatio));
      thumb.style.width = (thumbPct * 100) + '%';
      var progress = scroller.scrollLeft / max;
      var trackWidth = track.clientWidth;
      var thumbWidth = trackWidth * thumbPct;
      var x = progress * (trackWidth - thumbWidth);
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('[data-ing-scroller]').forEach(bind);
})();

  } catch(e) { console.error(e); }
})();
})();
